export enum QueryKey {
  Agreements = 'agreements',
  BannersData = 'bannersData',
  CertificatePaths = 'certificatePaths',
  DashboardData = 'dashboardData',
  Events = 'events',
  Event = 'event',
  TrainerMetric = 'TrainerMetric',
  EnrollEventSurveyData = 'enrollEventSurveyData',
  NewPassword = 'newPassword',
  UserFacsimile = 'userFacsimile',
  SurveyList = 'surveyList',
  KnowledgeBaseData = 'knowledgeBaseData',
  UsersAdministrationUserDetails = 'usersAdministrationUserDetails',
  UsersAdministrationCompanyList = 'usersAdministrationCompanyList',
  UsersAdministrationCyclicalLessons = 'usersAdministrationCyclicalLessons',
  UsersAdministrationUsersList = 'usersAdministrationUsersList',
  UsersAdministrationCoursesList = 'usersAdministrationCoursesList',
  UsersAdministrationDashboardStatistics = 'usersAdministrationDashboardStatistics',
  UsersAdministrationActiveCertificates = 'usersAdministrationActiveCertificates',
  UsersAdministrationUserCertificates = 'usersAdministrationUserCertificates',
  UsersAdministrationUsersPendingOffboardingList = 'usersAdministrationUsersPendingOffboardingList',
  KrkForm = 'krkForm',
  MyContractDetails = 'myContractDetails',
  ContractsStatements = 'contractsStatements',
  NfzOffices = 'nfzOffices',
  ContractTypedFormStructure = 'contractTypedFormStructure',
  B2bStatementTypedFormStructure = 'b2bStatementTypedFormStructure',
  Countries = 'countries',
  UserDocuments = 'userDocuments',
  ProvisionStationWithSheet = 'provisionStationWithSheet',
  ProvisionComplaints = 'provisionComplaints',
  ProvisionComplaintDetails = 'provisionComplaintDetails',
  ProvisionComplaintsStations = 'provisionComplaintsStations',
  ProvisionGrouped = 'provisionGrouped',
  ProvisionContractsStations = 'provisionContractsStations',
  ProvisionStationsList = 'provisionStationsList',
  ProvisionsContractsUsersStats = 'provisionsContractsUsersStats',
  ProvisionsContract = 'provisionsContract',
  ProvisionsContractUsers = 'provisionsContractUsers',
  ProvisionsCompanyWithContractSheets = 'provisionsCompanyWithContractSheets',
  ProvisionsContracts = 'provisionsContracts',
  ProvisionsUsersWithoutDocuments = 'provisionsUsersWithoutDocuments',
  ProvisionsUserWithoutDocumentsContracts = 'provisionsUserWithoutDocumentsContracts',
  ProvisionsUserWithoutDocumentsDetails = 'provisionsUserWithoutDocumentsDetails',
  ProvisionsContractsMonthStats = 'provisionsContractsMonthStats',
  SubstitutionsCreateAvailableUsers = 'substitutionsCreateAvailableUsers',
  SubstitutionsCreateStationsToCover = 'substitutionsCreateStationsToCover',
  SubstitutionsListAccepted = 'substitutionsListAccepted',
  SubstitutionsListRequested = 'substitutionsListRequested',
  SubstitutionsListRequestedByMe = 'substitutionsListRequestedByMe',
  SubstitutionsStatistics = 'substitutionsStatistics',
  SubstitutionsCompaniesList = 'substitutionsCompaniesList',
  SubstitutionsList = 'SubstitutionsList',
  UserExperience = 'userExperience',
  Notifications = 'notifications',
  UserInfo = 'userInfo',
  DocumentArchiveList = 'documentArchiveList',
  SearchResults = 'searchResults',
  SearchNewsResults = 'searchNewsResults',
  LegalFormsFormStructure = 'legalFormsFormStructure',
  LegalFormsCompanyAgents = 'legalFormsCompanyAgents',
  LegalFormsAttemptsList = 'legalFormsAttemptsList',
  ReportsFilters = 'reportsFilters',
  ReportFilters = 'reportFilters',
  DealersGroups = 'dealersGroups',
  Promotions = 'promotions',
  PathRequestsAdminList = 'pathRequestsAdminList',
  PathDetailsFormAdmin = 'pathDetailsFormAdmin',
  PathRequestsEventsFormAdmin = 'pathRequestsEventsFormAdmin',
  PathRequestsExamEnrollmentData = 'pathRequestsExamEnrollmentData',
  PathRequestsExamResultsEditData = 'pathRequestsExamResultsEditData',
  UserProfileDetails = 'userProfileDetails',
  UserPathRequests = 'userPathRequests',
  UserPathRequestInsuraceCompanyGroups = 'userPathRequestInsuraceCompanyGroups',
  PathRequestPaperDocumentsVerificationList = 'pathRequestPaperDocumentsVerificationList',
  PathRequestPaperDocumentsList = 'pathRequestPaperDocumentsList'
}
